import { css } from '@emotion/react';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { type ThemeProps } from '~/_shared/types/themeProps';
import { refreshPage } from '~/_shared/utils/document/document.helpers';
import { type TranslationFnc } from '~/_shared/utils/hooks';
import {
  type BoundaryCreateWMSOptimizedItem, type BoundaryCreateWMSOptimizedStatus,
} from '~/store/frontendState/mapTools/boundary/boundaryCreateWMSOptimized/boundaryCreateWMSOptimized.state';
import { WMSOptimizedTerritoriesProgressBarComponent } from './WMSOptimizedTerritoriesProgressBar.component';

const containerStyle = css({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  padding: '0 16px',
});

const titleStyle = ({ theme }: ThemeProps) => css({
  width: '50%',
  color: theme.textColors.primary,
});

type TopUnderbarWMSOptimizedTerritoriesProps = {
  isMobileVersion?: boolean;
  status: BoundaryCreateWMSOptimizedStatus;
  title: string;

  onCancel: () => void;
  onProcessFrozen: () => void;
};

export const TopUnderbarWMSOptimizedTerritoriesComponent: FC<TopUnderbarWMSOptimizedTerritoriesProps> = (props) => {
  const theme = useTheme();

  return (
    <div css={containerStyle}>
      {!props.isMobileVersion && <span css={titleStyle({ theme })}>{props.title}</span>}

      <WMSOptimizedTerritoriesProgressBarComponent
        onCancel={props.onCancel}
        onProcessFrozen={props.onProcessFrozen}
        status={props.status}
      />
    </div>
  );
};

export const renderBoundaryWMSOptimizedTerritoryItem = ({ isMobileVersion, item, onCancel, t }: {
  isMobileVersion?: boolean;
  item: BoundaryCreateWMSOptimizedItem;
  onCancel: () => void;
  t: TranslationFnc;
}) => ({
  children: (
    <TopUnderbarWMSOptimizedTerritoriesComponent
      isMobileVersion={isMobileVersion}
      status={item.status}
      title={t('boundaryAI.building.waitTimeInfo')}
      onCancel={onCancel}
      onProcessFrozen={() => refreshPage()}
    />
  ),
  icon: faExclamationTriangle,
  isWarningIcon: true,
  key: `optimizedTerritories-${item.id}`,
});
